export { default } from './Navigation';



// WEBPACK FOOTER //
// ./src/components/Footer/components/Navigation/index.ts